'use client';

import React, { ReactNode } from 'react';
import { Toast } from '@/ui/kit/components/toast';
import useScrollToTop from '@/hooks/useScrollToTop';
import ModalManager from '@/components/global/modal-manager';
type GlobalLayoutProps = {
  children: ReactNode;
};
export default function GlobalLayout({
  children
}: GlobalLayoutProps): JSX.Element {
  useScrollToTop();
  return <>
      {children}
      <Toast data-sentry-element="Toast" data-sentry-source-file="GlobalLayout.tsx" />
      <ModalManager data-sentry-element="ModalManager" data-sentry-source-file="GlobalLayout.tsx" />
    </>;
}